import styled from 'react-emotion';
import UnstyledBtn from '@ublend-npm/aulaui-next-web/Button';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import UnstyledAddIcon from '@material-ui/icons/Add';

export const Button = styled(UnstyledBtn)`
  background-color: ${colors.purple};
  color: ${colors.white};
  padding: 1px 16px 1px 10px;
  line-height: 16px;
  font-weight: 600;

  svg {
    opacity: 1;
  }

  &:hover {
    background-color: ${colors.purpleDark};
  }
`;

export const AddIcon = styled(UnstyledAddIcon)`
  font-size: 30px;
`;

export const Container = styled('div')`
  margin-left: 8px;
`;
